import Skeleton from '../Skeleton.jsx';
import ChatPanelAssistantMessageSkeleton from './ChatPanelAssistantMessageSkeleton.jsx';
import ChatPanelComposerSkeleton from './ChatPanelComposerSkeleton.jsx';

const MESSAGE_ROWS = [
  { isUser: false, agentVariant: 'full' },
  { isUser: true, lines: ['76%'] },
  { isUser: false, agentVariant: 'compact' },
  { isUser: true, lines: ['58%'] },
  { isUser: false, agentVariant: 'compact' },
];

/**
 * Full chat-panel loading overlay — mirrors {@link ChatPanelConversationView}
 * (message list + composer). No inner “top bar”: chrome lives in {@link ResizableSidePanel}.
 * @param {{ show?: boolean, alignMessagesStart?: boolean }} props
 */
const ChatPanelSkeleton = ({ show = false, alignMessagesStart = false }) => {
  if (!show) return null;

  return (
    <div
      className="absolute inset-0 z-20 flex flex-col bg-surface/95 backdrop-blur-[1px] dark:bg-surface/95"
      aria-busy="true"
      aria-label="Loading chat"
    >
      <div className="flex min-h-0 flex-1 flex-col px-1 py-3">
        <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-hidden">
          {MESSAGE_ROWS.map((msg, idx) => (
            <div
              key={idx}
              className={`flex w-full min-w-0 ${
                alignMessagesStart ? 'justify-start' : msg.isUser ? 'justify-end' : 'justify-start'
              }`}
            >
              {msg.isUser ? (
                <div className="w-[min(100%,52rem)] min-w-[min(100%,20rem)] max-w-full rounded-xl bg-brand-50 px-4 py-3 dark:bg-brand-900/30">
                  <div className="flex flex-col gap-2">
                    {msg.lines.map((w, i) => (
                      <Skeleton key={i} height={16} width={w} borderRadius={4} className="max-w-full" />
                    ))}
                  </div>
                </div>
              ) : (
                <ChatPanelAssistantMessageSkeleton variant={msg.agentVariant} widthMode="overlay" />
              )}
            </div>
          ))}
        </div>

        <div className="shrink-0 border-t border-edge bg-surface p-2 dark:bg-surface">
          <ChatPanelComposerSkeleton />
        </div>
      </div>
    </div>
  );
};

export default ChatPanelSkeleton;
